import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20224a12"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "维度：", -1));
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
import { queryEventResult } from '@/api/pay';
import { message } from 'ant-design-vue';
import FilterColumn from '@/views/paidEventBillboard/components/FilterColumn.vue';
import ExcelUtil from '@/common/ExcelUtil';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableContent',
  emits: ['changeLoading'],
  setup(__props, {
    expose,
    emit
  }) {
    const dimensionOptions = [{
      label: '包名',
      value: '_pkg',
      title: '_pkg'
    }, {
      label: '国家',
      value: '_country',
      title: '_country'
    }, {
      label: '应用版本',
      value: '_app_version',
      title: '_app_version'
    }, {
      label: 'AF-投放渠道',
      value: 'afsource',
      title: 'afsource'
    }, {
      label: 'AF-投放计划',
      value: 'afcampaign',
      title: 'afcampaign'
    }, {
      label: '内购ID',
      value: 'sku',
      title: 'sku'
    }];
    const basicColumns = [{
      title: '应用名',
      dataIndex: 'app',
      key: 'app',
      fixed: 'left'
    }, {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      fixed: 'left',
      sorter: {
        compare: (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      }
    }];
    const dataSource = ref([]);
    const originDataSource = ref([]);
    const pageTotal = ref(0);
    const pageIndex = ref(1);
    const pageSize = ref(10);
    const columns = ref([]);
    const dimensionList = ref([]);
    const indexList = ref([]);
    const searchForm = ref({});
    const exportLoading = ref(false);
    const originHeader = ref({});
    const loading = ref(false);
    const groupBy = ref('dbt_total');
    const tableContentRef = ref(null);
    let timer = null;
    const getColumn = col => {
      let arr = [];
      col.list.forEach(item => {
        arr = [...arr, ...item.value];
      });
      indexList.value = arr;
      handleColumn();
    };
    const exportExcel = () => {
      if (!dataSource.value.length) return;
      exportLoading.value = true;
      let paramData = {
        ...searchForm.value,
        req: {
          ...searchForm.value.req,
          groupBy: groupBy.value
        }
      };
      setTimeout(() => {
        ExcelUtil.exportExcel(columns.value, dataSource.value, `付费事件_${paramData.req.startTime}-${paramData.req.endTime}.xlsx`, false, [], () => {
          exportLoading.value = false;
        });
      }, 300); // 触发loading效果
    };
    const changeDime = e => {
      if (loading.value) return message.info('数据加载中...');
      if (e.length > 2) {
        message.warning('最多选择两个维度');
        return false;
      } else {
        dimensionList.value = e;
      }
      groupBy.value = dimensionList.value.length ? dimensionList.value.join(',') : 'dbt_total';
      if (!searchForm.value.apps) return message.error('请先点击“搜索”，再选择维度');
      // 节流
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        getData();
      }, 1000);
    };
    const changeSort = (pagination, filters, sorter) => {
      if (!sorter.order) {
        dataSource.value = JSON.parse(JSON.stringify(originDataSource.value));
      } else {
        if (sorter.field === 'date') {
          dataSource.value = dataSource.value.sort((a, b) => {
            return sorter.order === 'ascend' ? new Date(a.date).getTime() - new Date(b.date).getTime() : new Date(b.date).getTime() - new Date(a.date).getTime();
          });
        } else {
          dataSource.value = dataSource.value.sort((a, b) => {
            return sorter.order === 'ascend' ? a[sorter.field] - b[sorter.field] : b[sorter.field] - a[sorter.field];
          });
        }
      }
      pageIndex.value = 1;
    };
    const handleData = data => {
      dataSource.value = data.data.list;
      originDataSource.value = JSON.parse(JSON.stringify(data.data.list));
      pageTotal.value = data.data.total;
      originHeader.value = data.heads;
      handleColumn();
    }; // 处理数据
    const handleColumn = () => {
      let arr = [];
      Object.keys(originHeader.value).forEach(item => {
        var _ref;
        if ((_ref = [...indexList.value, ...(dimensionList.value.length ? dimensionList.value : ['dbt_total'])]) !== null && _ref !== void 0 && _ref.includes(item)) {
          arr.push({
            title: originHeader.value[item],
            dataIndex: item,
            key: item,
            sorter: {
              compare: (a, b) => {
                return a[item] - b[item];
              }
            },
            fixed: ['_pkg', '_country', '_app_version', 'afsource', 'afcampaign', 'sku'].includes(item) ? 'left' : null
          });
        }
      });
      columns.value = [...basicColumns, ...arr];
    }; // 处理表头
    const searchData = (searchObj = {}) => {
      pageIndex.value = 1;
      searchForm.value = {
        ...searchObj
      };
      getData();
    };
    const getData = async () => {
      loading.value = true;
      emit('changeLoading', loading.value);
      let paramData = {
        ...searchForm.value,
        req: {
          ...searchForm.value.req,
          groupBy: groupBy.value
        }
      };
      try {
        const {
          code,
          data
        } = await queryEventResult(paramData);
        if (code === '0') {
          handleData(data);
        }
      } catch (e) {}
      loading.value = false;
      emit('changeLoading', loading.value);
    };
    const handleScroll = () => {
      const e = new Event('resize');
      window.dispatchEvent(e);
    };
    onMounted(() => {
      var _document$querySelect;
      (_document$querySelect = document.querySelector('.revenue-content')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('scroll', () => {
        handleScroll();
      });
    });
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", {
        class: "table-content",
        ref_key: "tableContentRef",
        ref: tableContentRef
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_select, {
        disabled: loading.value,
        placeholder: "选择维度",
        options: dimensionOptions,
        value: dimensionList.value,
        mode: "multiple",
        "max-tag-count": 2,
        onChange: changeDime,
        getPopupContainer: triggerNode => triggerNode.parentNode || _ctx.document.body
      }, null, 8, ["disabled", "value", "getPopupContainer"])]), _createElementVNode("div", _hoisted_4, [_createVNode(FilterColumn, {
        onGetColumn: getColumn
      }), _createVNode(_component_a_button, {
        type: "primary",
        class: "export-btn",
        onClick: exportExcel,
        loading: exportLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["loading"])])]), _createVNode(_component_a_table, {
        sticky: "",
        columns: columns.value,
        "data-source": dataSource.value.slice((pageIndex.value - 1) * pageSize.value, pageIndex.value * pageSize.value),
        bordered: "",
        scroll: {
          x: 150 * columns.value.length
        },
        pagination: false,
        loading: loading.value,
        onChange: changeSort
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _ref2;
          return [column.dataIndex === 'firstBuyerRatio' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString((_ref2 = (record === null || record === void 0 ? void 0 : record.firstBuyerRatio) * 100) === null || _ref2 === void 0 ? void 0 : _ref2.toFixed(2)) + "%", 1)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record !== null && record !== void 0 && record.prodName ? record === null || record === void 0 ? void 0 : record.prodName : record === null || record === void 0 ? void 0 : record.sku), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        total: pageTotal.value,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        "show-size-changer": "",
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[1] || (_cache[1] = $event => pageSize.value = $event)
      }, null, 8, ["total", "current", "page-size"])], 512);
    };
  }
});